import { render, staticRenderFns } from "./SamplesCards.vue?vue&type=template&id=74f8bb07&scoped=true&"
import script from "./SamplesCards.vue?vue&type=script&lang=js&"
export * from "./SamplesCards.vue?vue&type=script&lang=js&"
import style0 from "./SamplesCards.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SamplesCards.vue?vue&type=style&index=1&id=74f8bb07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f8bb07",
  null
  
)

export default component.exports